//#region Imports

// @angular
import {Routes} from '@angular/router';

// @ew
import {RouteName} from '@ew/enums';
import {RequiredParam, urlParamVerificationGuard} from '@ew/verification-param';

//#endregion

/**
 * The routes for the auth module in the mobile app.
 */
export const authMobileRoutes: Routes = [
  {
    title: RouteName.Login,
    path: RouteName.Login,
    loadComponent: async () => (await import('@ew-mobile/login')).LoginComponent,
  },
  {
    title: RouteName.SignUp,
    path: RouteName.SignUp,
    loadComponent: async () => (await import('@ew-mobile/sign-up')).SignUpComponent,
  },
  {
    title: RouteName.ForgotPassword,
    path: RouteName.ForgotPassword,
    loadComponent: async () => (await import('@ew-mobile/forgot-password')).ForgotPasswordComponent,
  },
  {
    title: RouteName.Verification,
    path: RouteName.Verification,
    loadComponent: async () => (await import('@ew-mobile/verification')).VerificationComponent,
    canActivate: [urlParamVerificationGuard(RequiredParam.Token, RouteName.Login)],
  },
  {
    title: RouteName.ResendCode,
    path: RouteName.ResendCode,
    loadComponent: async () =>
      (await import('@ew-mobile/send-verification-code')).SendVerificationCodeComponent,
    canActivate: [urlParamVerificationGuard(RequiredParam.Token, RouteName.Login)],
  },
  {
    title: RouteName.ResetPassword,
    path: RouteName.ResetPassword,
    loadComponent: async () => (await import('@ew-mobile/reset-password')).ResetPasswordComponent,
    canActivate: [urlParamVerificationGuard(RequiredParam.Token, RouteName.Login)],
  },
];
